import React from 'react';
import { Link } from 'react-router-dom';

const Error404 = () => (
  <div>
    <div style={{ textAlign: 'center', marginTop: 30 }}>
      <div className="error-wrapper">
        <div className="container">
          <div className="col-md-8 offset-md-2">
            <img
              src="https://mshanken.imgix.net/cao/bolt/2017-09/transparent-404.png"
              alt="404"
              style={{
                width: '100%',
                maxWidth: 300,
                marginBottom: 30,
                filter: 'grayscale(1)',
              }}
            />
            <p className="sub-content">
              The page you are attempting to reach is currently not available.
              This may be because the page does not exist or has moved.
            </p>
          </div>
          <Link to="/" className="btn btn-primary btn-lg">
            Back Home
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default Error404;
